module.exports = __webpack_public_path__ + "img/motorcycle-green-right.17c91059.jpg";